import PropTypes from "prop-types";
import React from "react";

const Info = ({ countyName, searchMetrics, searchTerm }) => (
  <div
    className="print-info"
    role="region"
    aria-label="Report information"
    aria-describedby="report-info-description"
  >
    <h1 className="print-info--title">{countyName} County</h1>
    <p className="print-info--metrics" id="report-info-description">
      Search Metrics by {searchMetrics}/Date | {searchTerm}
    </p>
  </div>
);

Info.propTypes = {
  countyName: PropTypes.string,
  searchMetrics: PropTypes.string,
  searchTerm: PropTypes.string,
};

export default Info;
